import React, { useState, useEffect, useCallback } from 'react';
import Modal from '@salesforce/design-system-react/components/modal';
import Button from '@salesforce/design-system-react/components/button';
// import { standardUsersSelector } from '../../store/standardUsers/slice';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash.debounce';
import toast, { Toaster } from 'react-hot-toast';
import {
  DataTable,
  DataTableCell,
  DataTableColumn,
  DataTableRowActions,
} from '@salesforce/design-system-react';
import {
  deleteHedgeFundUser,
  getHedgeFundManagers,
  getHedgeFunds,
  getHedgeFundStandardUsers,
  hedgeFundsManagersSelector,
  // hedgeFundsManagersSelector,
  hedgeFundsSelector,
  hedgeFundsUsersSelector,
  // hedgeFundsUsersSelector,
  updateHedgeFundNotes,
} from '../../store/hedgeFunds/slice';
import { getTimeIntervalText } from '../../utilities/datetime';
import UserSvg from '../../assets/users';
import moment from 'moment';
// import ActionStandardUser from './actionStandarduser';
import { ACTION_TYPES } from '../../constants/types';
import $ from 'jquery';
import ActionHedgeFundStandardUser from './actionHedgeFundStandardUser';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const CustomNameCell = ({ children, ...props }) => {
  const { item } = props;

  const TdColour = item.status === true ? 'tranparent' : 'Silver';
  const defaultCursor = item.status === true ? 'default' : 'not-allowed';
  const name = children
    ? children
    : (item?.first_name ? item.first_name + ' ' : '') + (item?.last_name ? item.last_name : '');
  return (
    <td style={{ backgroundColor: TdColour, cursor: defaultCursor }} title={children} {...props}>
      {/* <Link
        to={`/admin/standard-users/${item.first_name}/overview`}
      > */}
      <span className="slds-m-right_xx-small">
        <UserSvg color={item.color || '#CCCCCC'} />
      </span>
      <span style={{ fontWeight: 'bold' }}>{name}</span>
      {/* </Link> */}
    </td>
  );
};

CustomNameCell.displayName = DataTableCell.displayName;

const CustomTypeCell = ({ children, ...props }) => {
  const { item } = props;
  const TdColour = item.status === true ? 'tranparent' : 'Silver';
  const defaultCursor = item.status === true ? 'default' : 'not-allowed';

  return (
    <td style={{ backgroundColor: TdColour, cursor: defaultCursor }} title={children} {...props}>
      <div style={{ fontWeight: 'bold', color: '#fff', display: 'flex' }}>
        <span
          style={{
            background: children === 'manager' ? '#007bff' : '#17a2b8',
            fontSize: '12px',
            borderRadius: '30px',
            padding: '0px 8px 0px 8px',
            lineHeight: '2',
          }}
        >
          {children}
        </span>
      </div>
    </td>
  );
};

CustomTypeCell.displayName = DataTableCell.displayName;

const CustomDataTableDate = ({ children, ...props }) => {
  const { item } = props;
  const TdColour = item.status === true ? 'tranparent' : 'Silver';
  const defaultCursor = item.status === true ? 'default' : 'not-allowed';

  return (
    <td style={{ backgroundColor: TdColour, cursor: defaultCursor }} title={children} {...props}>
      {moment(item.createdAt).format('MM/D/yyyy HH:mm:ss')}
    </td>
  );
};
CustomDataTableDate.displayName = DataTableCell.displayName;

const CustomStatusCell = ({ children, ...props }) => {
  const { item } = props;
  const TdColour = item.status === true ? 'tranparent' : 'Silver';
  const defaultCursor = item.status === true ? 'default' : 'not-allowed';

  return (
    <td style={{ backgroundColor: TdColour, cursor: defaultCursor }} title={children} {...props}>
      <div style={{ fontWeight: 'bold', color: '#fff', display: 'flex' }}>
        <span
          style={{
            background: item.status === true ? 'green' : 'crimson',
            fontSize: '12px',
            borderRadius: '30px',
            padding: '0px 8px 0px 8px',
            lineHeight: '2',
          }}
        >
          {item.status === true ? 'active' : 'inactive'}
        </span>
      </div>
    </td>
  );
};
CustomStatusCell.displayName = DataTableCell.displayName;

const CustomEmailCell = ({ children, ...props }) => {
  const { item } = props;
  const TdColour = item.status === true ? 'tranparent' : 'Silver';
  const defaultCursor = item.status === true ? 'default' : 'not-allowed';

  return (
    <td style={{ backgroundColor: TdColour, cursor: defaultCursor }} title={children} {...props}>
      {children || ''}
    </td>
  );
};
CustomEmailCell.displayName = DataTableCell.displayName;

const CustomPhoneCell = ({ children, ...props }) => {
  const { item } = props;
  const TdColour = item.status === true ? 'tranparent' : 'Silver';
  const defaultCursor = item.status === true ? 'default' : 'not-allowed';

  return (
    <td style={{ backgroundColor: TdColour, cursor: defaultCursor }} title={children} {...props}>
      {children || ''}
    </td>
  );
};
CustomPhoneCell.displayName = DataTableCell.displayName;

const CustomActionTableDate = ({ children, ...props }) => {
  const { item } = props;
  const TdColour = item.status === true ? 'tranparent' : 'Silver';
  const defaultCursor = item.status === true ? 'default' : 'not-allowed';
  const suspend = item.status === true ? ACTION_TYPES.SUSPEND : ACTION_TYPES.ENABLE
  const pause = item.isSyncPaused === false ? ACTION_TYPES.PAUSE : ACTION_TYPES.RESUME


  return (
    <td style={{ backgroundColor: TdColour, cursor: defaultCursor }} title={'Actions'} {...props}>
      {item.role === "user" && <>
        <Button
          className='CustomButton'
          key={suspend}
          label={suspend}
          responsive
          variant="neutral"
          title="Stops user from signing in"
          onClick={() =>
            props.setActionHedgeFundStandardUserModal({
              open: true,
              type: suspend,
              name: item.name,
              id: item._id,
              status: item.status,
              isSyncPaused: item.isSyncPaused
            })
          }
        />
        {/* <Button
          key={pause}
          label={pause}
          responsive
          variant="neutral"
          title="Supend and pause sync"
          onClick={() => props.setActionHedgeFundStandardUserModal({
            open: true,
            type: ACTION_TYPES.PAUSE,
            name: item.first_name,
            id: item._id,
            status: item.status,
            isSyncPaused: item.isSyncPaused
          })}
        /> */}
        <Button
          className='CustomButton'
          key="Remove"
          label="Remove"
          responsive
          variant="text-destructive"
          title="Remove user and delete data"
          onClick={() =>
            props.setActionHedgeFundStandardUserModal({
              open: true,
              type: ACTION_TYPES.REMOVE,
              name: item.first_name,
              id: item._id,
              status: item.status,
              isSyncPaused: item.isSyncPaused
            })
          }
        />
      </>
      }
    </td>
  );
};
CustomActionTableDate.displayName = DataTableCell.displayName;

const DetailHedgeFundUser = (props) => {
  const { modelData, closeModal } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { hedgeFundManagers, hedgeFundStandardUsers, loading, pagination } =
    useSelector(hedgeFundsSelector);
  const dispatch = useDispatch();
  const [sortColumn, setSortColumn] = useState('opportunityName');
  const [sortColumnDirection, setSortColumnDirection] = useState({
    opportunityName: 'asc',
  });
  const [items, setItems] = useState([]);
  const [paginated, setPaginated] = useState(0);
  // const [selection, setSelection] = useState([]);
  const [searchText, setSearchText] = useState('');
  // const [accountsDropDown, setAccountsDropDown] = useState('0');
  const [hasMore, setHasMore] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [text, setText] = useState('Recently updated');
  const [APICalledTime, setAPICalledTime] = useState(new Date());
  const [actionHedgeFundStandardUserModal, setActionHedgeFundStandardUserModal] = useState({
    open: false,
    type: '',
    email: modelData.email
  });
  const [rowStatus, setRowStatus] = useState([]);

  useEffect(() => {
    setIsOpen(modelData.open);
  }, [modelData]);

  const handleChanged = (event, data) => {
    // setSelection(data.selection);
  };

  const handleSort = (sortColumn, ...rest) => {
    const sortProperty = sortColumn.property;

    const { sortDirection } = sortColumn;

    setSortColumn(sortProperty);
    setSortColumnDirection({
      [sortProperty]: sortDirection,
    });
  };

  const handleLoadMore = () => {
    if (!loading && !isPageLoading) {
      setIsPageLoading(true);
      setTimeout(() => {
        if (pagination?.pages <= 1 || paginated >= pagination?.pages) {
          setHasMore(false);
          setIsPageLoading(false);
          return;
        }

        if (pagination.currentPage >= pagination.pages) {
          setHasMore(false);
          setIsPageLoading(false);
          return;
        }
        let url = new URLSearchParams(pagination.nextPageUrl);
        setPaginated(paginated + 1);
        dispatch(
          getHedgeFundManagers({
            limit: url.get('limit'),
            offset: url.get('offset'),
            q: searchText,
          })
        );
        dispatch(
          getHedgeFundStandardUsers({
            limit: url.get('limit'),
            offset: url.get('offset'),
            q: searchText,
          })
        );
        setIsPageLoading(false);
      }, 1000);
    }
  };

  const toggleOpen = () => {
    closeModal({
      open: false,
      type: '',
    });
  };

  useEffect(() => {
    if (modelData.email) {
      dispatch(getHedgeFundManagers(modelData.email));
      dispatch(getHedgeFundStandardUsers(modelData.email));
    }
  }, [dispatch, modelData]);

  useEffect(() => {
    if (hedgeFundManagers.length > 0 || hedgeFundStandardUsers.length > 0) {
      let allData = hedgeFundManagers.concat(hedgeFundStandardUsers);
      setItems(allData);
    }
    setAPICalledTime(new Date());
    const data = getTimeIntervalText(APICalledTime);
    setText(data);
  }, [hedgeFundManagers, hedgeFundStandardUsers]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const removeHedgeFundStandardUser = (id) => {
    // dispatch remove contact API
    if (id) {
      dispatch(deleteHedgeFundUser(id)).then((res) => {
        if (res?.payload?.status === 200) {
          // setShowToast(true);
          setActionHedgeFundStandardUserModal({
            open: false,
            type: '',
          });
          dispatch(getHedgeFundStandardUsers(modelData.email));
        }
      })
    }
  }

  return (
    <div style={{ overflow: 'hidden', height: '100%' }}>
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        className="tableModal"
        size="large"
        footer={[<Button className='modal-cancel-button' key="cancel" label="Close" onClick={toggleOpen} />]}
        onRequestClose={toggleOpen}
        heading={`${capitalizeFirstLetter(modelData.type)}: Hedge Fund User`}
      >
        <div style={{ height: '50vh', padding: '0px 8px 0px 8px' }}>
          <DataTable
            assistiveText={{
              actionsHeader: 'actions',
              columnSort: 'sort this column',
              columnSortedAscending: 'asc',
              columnSortedDescending: 'desc',
              selectAllRows: 'Select all rows',
              selectRow: 'Select this row',
            }}
            fixedHeader
            fixedLayout
            items={items}
            id="HedgeFundUsersModalTable"
            onRowChange={handleChanged}
            onSort={handleSort}
            // selection={selection}
            // selectRows="checkbox"
            hasMore={hasMore}
            onLoadMore={handleLoadMore}
            noRowHover
          >
            <DataTableColumn label="Name" property="name" width="12rem"
            >
              <CustomNameCell />
            </DataTableColumn>

            <DataTableColumn
              isSorted={sortColumn === 'email'}
              label="Email"
              property="email"
              sortable
              sortDirection={sortColumnDirection.email}
              width="15rem"

            >
              <CustomEmailCell />
            </DataTableColumn>

            <DataTableColumn
              sortable
              isDefaultSortDescending
              label="Phone"
              property="contact_number"
              width="12rem"
            >
              <CustomPhoneCell />
            </DataTableColumn>
            <DataTableColumn label="Type" property="role" width="8rem">
              <CustomTypeCell />
            </DataTableColumn>

            <DataTableColumn label="Created Date" width="10rem">
              <CustomDataTableDate />
            </DataTableColumn>

            <DataTableColumn label="Status" width="8rem">
              <CustomStatusCell />
            </DataTableColumn>

            {/* @TODO */}
            <DataTableColumn label="Action" width="8rem">
              <CustomActionTableDate setActionHedgeFundStandardUserModal={setActionHedgeFundStandardUserModal} />
            </DataTableColumn>
          </DataTable>

          <ActionHedgeFundStandardUser
            modelData={actionHedgeFundStandardUserModal}
            closeModal={setActionHedgeFundStandardUserModal}
            removeData={removeHedgeFundStandardUser}
          />
        </div>
      </Modal>
    </div>
  );
};

export default DetailHedgeFundUser;
